// extracted by mini-css-extract-plugin
export default {"video-speed":"SlKzjRAbkNwQS7VvcHtxMw==","fast-forward":"V-FeAMot-jnIISffz3jFsg==","fast-back":"rJqYB3CzcT61pmZa9yV03g=="};